<template>
    <div class="container" v-if="show">
        <div class="box-share">
            <div class="model"></div>
            <div class="content">
                <div class="image-container">
                    <swiper
                        :options="swiperOption"
                        class="swiper-wrap"
                        ref="mySwiper"
                        v-if="imageList.length != 0"
                    >
                        <swiper-slide v-for="(item, index) in imageList" :key="index">
                            <img :src="item" alt="" />
                        </swiper-slide>
                        <!-- 常见的小圆点 -->
                    </swiper>
                </div>
                <div class="points-container">
                    <div
                        class="point"
                        :class="imgIndex === index ? 'point-active' : ''"
                        v-for="(item, index) in imageList"
                        :key="index"
                    ></div>
                </div>

                <div class="desc" v-html="desc"></div>
            </div>
            <div class="close" @click="close"></div>
        </div>
    </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';
import 'swiper/swiper-bundle.css';

export default {
    name: 'album',
    components: {
        Swiper,
        SwiperSlide
    },
    directives: {
        swiper: directive
    },
    props: ['imageList', 'desc', 'show'],
    data() {
        const that = this;
        return {
            imgIndex: 0,
            swiperOption: {
                //是一个组件自有属性，如果notNextTick设置为true，组件则不会通过NextTick来实例化swiper，也就意味着你可以在第一时间获取到swiper对象，假如你需要刚加载遍使用获取swiper对象来做什么事，那么这个属性一定要是true
                notNextTick: true,
                //循环
                loop: false,
                //设定初始化时slide的索引
                initialSlide: 0,
                //自动播放
                // autoplay: {
                //     delay: 1500,
                //     stopOnLastSlide: false,
                //     /* 触摸滑动后是否继续轮播 */
                //     disableOnInteraction: false
                // },
                //滑动速度
                speed: 800,
                //滑动方向
                direction: 'horizontal',
                //小手掌抓取滑动
                grabCursor: true,
                on: {
                    //滑动之后回调函数
                    slideChangeTransitionStart: function() {
                        /* realIndex为滚动到当前的slide索引值 */
                        that.imgIndex = this.realIndex;
                    }
                }
                //分页器设置
                // pagination: {
                //     el: '.swiper-pagination',
                //     clickable: true,
                //     type: 'bullets'
                // }
            }
        };
    },
    watch: {
        show(n, o) {
            if (n) {
                this.imgIndex = 0;
            }
        }
    },
    methods: {
        close() {
            this.$emit('close');
        }
    }
};
</script>
<style lang="less" scoped></style>
<style lang="less" scoped>
@import '~@/common/style/common.less';
.container {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    z-index: 1111;
    justify-content: center;
    align-items: center;
}
.box-share {
    z-index: 1;
    .content {
        z-index: 1;
        width: 300px;
        display: flex;
        border-radius: 3px;
        flex-direction: column;
        align-items: center;
        background-color: #fff;
        .image-container {
            width: 243px;
            height: 200px;
            position: relative;
            margin-top: 28px;
            .swiper-wrap {
                position: relative;
                .swiper-slide {
                    position: relative;
                    display: flex;
                    align-items: center;
                    img {
                        width: 180px;
                        height: 180px;
                        margin: auto;
                        left: 0;
                        right: 0;
                    }
                }
            }
        }
        .points-container {
            position: relative;
            display: flex;
            width: 100%;
            align-items: center;
            align-content: center;
            justify-content: center;
            .point {
                margin-left: 10px;
                display: inline-block;
                width: 6px;
                height: 6px;
                display: inline-block;
                border-radius: 100%;
                background: #000;
                opacity: 0.2;
            }
            .point-active {
                background: #f0c05a;
            }
        }
        .desc {
            .f-12();
            color: #292738;
            width: 257px;
            margin: auto;
            text-align: center;
            margin-top: 50px;
            margin-bottom: 30px;
        }
    }
    .close {
        margin: auto;
        margin-top: 30px;
        .backgroundImage(28px, 28px, '~@assets/img/popup-close@2x.png');
    }
}
</style>
